import React from "react";
import { Spring } from "react-spring/renderprops";
import styled from "styled-components";
import { content } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { useIntersectionObserver } from "@lkf/hooks";
import { getResponsiveCount } from "@tootools/number";

export interface ChartyKpiCounterProps {
  count: number;
  isNarrow?: boolean;
  locale: Locale;
  onClick?: () => void;
  isPercentage: boolean;
  disableAnimation?: boolean;
}

const Count = styled.div<{ clickable: boolean }>`
  display: inline-block;
  font-size: 28px;
  color: ${(props) => content(props, "secondary")};
  cursor: ${(props) =>
    props.clickable ? "var(--cursor-magic-wand)" : "default"};
  :hover {
    color: ${(props) => props.clickable && content(props, "primary")};
  }
`;

export default function ChartyKpiCounter({
  count,
  isNarrow,
  locale,
  onClick,
  isPercentage,
  disableAnimation,
}: ChartyKpiCounterProps) {
  const { ref, inView } = useIntersectionObserver();
  return (
    <Count clickable={!!onClick} onClick={onClick} ref={ref}>
      {!inView || disableAnimation
        ? getResponsiveCount(count, locale, isPercentage, isNarrow)
        : count && (
            <Spring from={{ number: 0 }} to={{ number: count }}>
              {(props) =>
                getResponsiveCount(props.number, locale, isPercentage, isNarrow)
              }
            </Spring>
          )}
    </Count>
  );
}
